var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 141,
    viewBox: "0 0 375 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.2 57.9678C118.564 43.4951 114.765 30.2456 106.714 28.3742C98.6631 26.5028 89.4094 36.7183 86.0453 51.191C82.6812 65.6638 86.4806 78.9133 94.5314 80.7846C102.582 82.656 111.836 72.4406 115.2 57.9678Z",
    fill: "#52B2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6443 55.0304C105.366 56.4113 109.083 61.6246 112.992 65.6945C117.649 70.5444 123.322 74.1104 129.524 76.6492C143.507 82.3761 158.803 82.2162 173.634 83.035C174.326 83.0738 175.01 83.1222 175.678 83.3257C176.366 83.5292 176.778 83.8006 177.03 84.3868C176.986 84.2899 177.132 84.9343 177.117 84.7453C177.132 84.9004 177.127 85.0603 176.986 85.1911C176.642 85.5206 175.664 85.758 175.106 85.9421C171.696 87.0807 168.173 87.8268 164.636 88.4276C157.504 89.634 150.237 90.2445 143.279 92.3037C141.593 92.8027 139.791 93.2727 138.395 94.3919C137.077 95.4481 136.292 97.2505 137.368 98.767C138.429 100.269 140.668 100.38 142.32 100.657C144.277 100.986 146.254 101.238 148.231 101.437C156.041 102.217 163.934 102.217 171.778 102.43C187.742 102.866 203.712 103.302 219.676 103.738C221.634 103.791 223.596 103.845 225.553 103.898C227.424 103.951 227.424 101.044 225.553 100.991C209.545 100.555 193.537 100.119 177.529 99.6779C169.699 99.4647 161.855 99.3775 154.035 98.9608C150.212 98.7573 146.39 98.4279 142.615 97.7689C141.767 97.6187 140.837 97.5315 140.023 97.236C139.955 97.2117 139.65 97.1051 139.776 97.1584C139.398 97.0082 139.892 96.9792 139.752 97.1633C139.655 97.2893 139.791 97.11 139.834 97.0373C140.532 95.9859 142.378 95.6129 143.618 95.2349C150.561 93.1128 157.829 92.4829 164.961 91.3007C168.503 90.7145 172.03 89.9926 175.45 88.883C177.117 88.3452 179.104 87.8414 179.801 86.0341C180.378 84.537 179.767 82.7492 178.619 81.6929C177.267 80.4526 175.383 80.22 173.634 80.1231C171.686 80.0165 169.738 79.939 167.79 79.8567C163.866 79.6871 159.946 79.5175 156.031 79.2219C148.851 78.6793 141.675 77.6812 134.795 75.4767C128.618 73.4999 122.644 70.5347 117.746 66.2323C113.206 62.2496 109.804 56.8474 104.451 53.8289C103.191 53.1166 101.829 52.5643 100.419 52.2251C98.5977 51.7891 97.8225 54.5895 99.6443 55.0304Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.939 82.0029C373.939 67.4531 366.724 54.9189 356.336 49.2017L356.346 49.0806L304.291 25.9114L304.102 27.0306C295.506 19.5304 284.905 15.0972 273.437 15.0972C244.735 15.0972 221.469 42.8304 221.469 77.0464C221.469 111.262 244.735 138.996 273.437 138.996C281.422 138.996 288.98 136.849 295.739 133.012L351.845 116.931L351.855 116.771C364.593 112.512 373.939 98.5634 373.939 82.0029Z",
    fill: "#52B2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.608 25.9308C252.927 19.3318 262.947 15.48 273.727 15.48C302.599 15.48 326.001 43.1067 326.001 77.1918C326.001 111.272 302.594 138.904 273.727 138.904",
    stroke: "black",
    strokeWidth: 3.39156,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.395 59.5071C320.395 59.5071 303.622 74.585 317.682 101.034",
    stroke: "black",
    strokeWidth: 1.45353,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.336 49.2017C356.336 49.2017 373.304 57.5207 373.938 82.0029C374.568 106.485 354.403 116.233 354.403 116.233L329.896 123.394",
    stroke: "black",
    strokeWidth: 1.45353,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.713 28.3678L34.5987 1.3855L19.0605 74.8757L94.5324 80.7819L106.713 28.3678Z",
    fill: "#52B2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.426 71.8524C105.172 78.3303 99.6103 81.9592 94.5327 80.777C86.4801 78.9068 82.6816 65.6555 86.0441 51.1833C88.7767 39.4291 95.3951 30.4851 102.096 28.5374",
    stroke: "black",
    strokeWidth: 1.45353,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0171 43.4148C51.037 23.0007 45.3785 4.05969 33.3785 1.1088C21.3785 -1.84209 7.58108 12.3146 2.56112 32.7287C-2.45884 53.1428 3.19962 72.0838 15.1996 75.0347C27.1997 77.9856 40.9971 63.8289 46.0171 43.4148Z",
    fill: "#52B2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1939 75.0355C3.1975 72.0848 -2.46155 53.1454 2.55795 32.7331C7.57746 12.3207 21.3763 -1.83662 33.3775 1.11404",
    stroke: "black",
    strokeWidth: 1.45353,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.207 51.7162C105.207 51.7162 98.5978 52.5302 102.6 58.7998L95.1094 56.7212L98.2296 47.5688L105.207 51.7162Z",
    fill: "#52B2E2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.68,
    height: 140.599,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIllustration);
export default __webpack_public_path__ + "static/media/callIllustration.9d4a2924f45bbfb384be9d665e0f8006.svg";
export { ForwardRef as ReactComponent };